@if (busy) {
  <div class="flex flex-col items-center justify-center py-8">
    <div class="text-center">
        <div class="relative w-20 h-20 mx-auto mb-6">
          <div class="absolute inset-0 rounded-full border-4 border-green-200 animate-spin"></div>
          <div class="absolute inset-2 rounded-full border-4 border-green-400 border-t-transparent animate-spin" style="animation-direction: reverse; animation-duration: 1.5s;"></div>
          <div class="absolute inset-0 flex items-center justify-center">
            <mat-icon class="text-green-600 text-2xl animate-pulse">security</mat-icon>
          </div>
        </div>
        <h3 class="mb-2 text-gray-700 inline-flex">
          <mat-icon class="mr-2">account_balance</mat-icon>
          Secure Bank Connection Active
        </h3>
        <p class="text-gray-500">Please wait...</p>
      </div>
  </div>
}

<div [class.hidden]="busy">
  <div class="p-2 sm:p-4">
    <form [formGroup]="bankAccountForm" (submit)="onSubmit()">

      @if (isEditMode) {
        <div class="flex flex-col gap-6">
          <!-- Bank Account Preview Card -->
          <div class="overflow-hidden border border-blue-400 bg-blue-100 rounded-xl p-6">
            <div class="flex items-center gap-2 mb-4">
              <mat-icon class="text-gray-700">account_balance</mat-icon>
              <h3>{{ userBankAccount?.bankName }}</h3>
            </div>

            <div class="grid grid-cols-2">
              <div>
                <p class="uppercase text-sm font-medium">Account Type</p>
                <p class="font-medium">{{ bankAccountType[userBankAccount?.accountType] | titlecase }}</p>
              </div>
              <div>
                <p class="uppercase text-sm font-medium">Account Number</p>
                <p class="font-medium tracking-wider">••••{{ userBankAccount?.last4Digits }}</p>
              </div>
            </div>
          </div>

          <!-- Edit Section -->
          <div>
            <div class="w-full mb-2 flex flex-col">
              <mat-checkbox formControlName="updateJobs">Assign To All Jobs</mat-checkbox>
              @if (sideMarkOptions?.length > 1) {
                <mat-checkbox formControlName="updateProjects">Assign To Sidemark</mat-checkbox>
              }
            </div>

            @if (showSideMark) {
              <mat-form-field class="w-full mb-2" [subscriptSizing]="'dynamic'">
                <mat-label>Sidemark</mat-label>
                <mat-select formControlName="projectIds" multiple>
                  @for (item of sideMarkOptions; track item) {
                    <mat-option [disabled]="isDisableSideMarkOption(item.value.toString())" [value]="item.value">{{ item.label }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }

            <mat-form-field class="w-full edit-mode-field" [subscriptSizing]="'dynamic'">
              <mat-label>Nickname</mat-label>
              <input matInput type="text" formControlName="nickname"
                    placeholder="Enter a friendly name for this account">
              <mat-hint>This nickname helps you identify this account easily</mat-hint>
            </mat-form-field>

            <div class="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <div class="flex gap-1">
                <mat-icon class="text-amber-600 text-base">info</mat-icon>
                <p class="text-sm text-amber-800">
                  <strong>Note:</strong> Only the nickname and sidemark assignments can be modified.
                  For other changes, please add a new account or contact support.
                </p>
              </div>
            </div>
           </div>
        </div>
      } @else {
        <div class="w-full pb-4">
          <div id="jpmorgan-bank-dropin-mount"></div>
        </div>

        <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
          <mat-label>Nickname</mat-label>
          <input matInput type="text" formControlName="nickname" id="nickname">
        </mat-form-field>

        <mat-checkbox formControlName="setAsDefault" class="py-2">Set as Default Payment Method</mat-checkbox>

        <div class="w-full flex flex-col gap-2 pb-2">
          <mat-checkbox formControlName="updateJobs">Assign To All Jobs</mat-checkbox>
          @if (sideMarkOptions?.length > 1) {
            <mat-checkbox formControlName="updateProjects">Assign To Sidemark</mat-checkbox>
          }
        </div>

        @if (showSideMark) {
          <mat-form-field class="w-full" [subscriptSizing]="'dynamic'">
            <mat-label>Sidemark</mat-label>
            <mat-select formControlName="projectIds" multiple>
              @for (item of sideMarkOptions; track item) {
                <mat-option [disabled]="isDisableSideMarkOption(item.value.toString())" [value]="item.value">{{ item.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <div class="w-full p-4 bg-gray-50 rounded-lg flex gap-2">
          <mat-icon class="icon-size-5 mt-1">info</mat-icon>
          <p class="text-gray-600">By adding this bank account, I authorize Metropolitan to debit my bank account for agreed charges and terms.</p>
        </div>
      }

      <!-- Form Actions -->
      <div class="flex flex-row mt-4 justify-between">
        <button type="button" class="bg-white" mat-raised-button color="default" (click)="onCancel()">
          <mat-icon>arrow_back</mat-icon>
          Cancel
        </button>

        <button type="submit"
          [disabled]="!bankAccountForm.valid || (bankAccountForm.pristine && !isEditMode)"
          id="submit-bank-account-form" mat-raised-button color="primary">
          {{ isEditMode ? 'Update' : 'Save' }}
          <mat-icon svgIcon="heroicons_outline:check-circle"></mat-icon>
        </button>
      </div>

    </form>
  </div>
</div>
